import { EMPTY_WIDGET_COLORS_TEMPLATE } from "./styling/widget-colors"
import { EXAMPLE_TOOLBAR_BUTTONS_CONFIG } from "./widgets/Toolbar/example-config"
import { DEFAULT_LAYOUT_CONFIG } from "./widgets/IFCViewerV4/shared/layout-config"

export const DEFAULT_WIDGET_CONFIG = {
  general: {
    voteForUserActionsDisabledWhenLoading: true,
    syncWithUserActionsDisabled: true,
    showLoadingOverlay: true
  },
  SplitLayout: {
    panelstyleExtra: 'noScrollBars',
  },
  SelectBox: {
    preSelectFirstItem: true
  },
  ToggleWidget: {
    appearance: 'icon',
    publishTopic: 'defaultTopic',
    enabledBgColor: '#00589b',
    disabledBgColor: 'gray'
  },
  "BB ButtonPopup": {
    popupMinWidth: '600px',
    popupMaxWidth: '100vw',
    popupMinHeight: '0',
    popupMaxHeight: '100vh',
    popupCloseOnBackdropClick: true,
    popupCloseOnEscapeKey: true
  },
  BBDForm: {
    backendDatatypeValidationEnabled: true
  },
  BBParameterLinkEmptyWidget: {
    showLoadingOverlay: false
  },
  JobStatus: {
    statusLabels: {
      "RUNNING": "running",
      "QUEUED": "queued"
    },
    statusTextTemplateString: "<b>{{.count}}</b> {{.status}}",
    refetchInterval: "5"
  },
  IFCJSViewerV3: {
    resetSelectionOnSparqlUpdate: true
  },
  "Image Gallery": {
    fullscreenObjectFit: "contain"
  },
  "Shacl Form": {
    graph: "https://wistor.nl/shaclform-default-graph-to-save/change-this",
    uriPrefix: "https://wistor.nl/resource/",
    successMessage: "Data saved successfully!",
    failureMessage: "Failed to save data.",
    submitButtonTitle: "Save",
    allowSubmitWithValidationErrors: true,
    preloadLabelsTtl: true,
    showLoadingIndicator: false,
    dense: true,
    showNodeIds: false,
    showRootShapeLabel: false,
    loadingText: "Loading form..."
  },
  "Tree++": {
    selectMode: "disabled",
    checkedItemsPublishMode: "all",
    checkboxLayout: "nested",
    dndDragActivationMode: "handle"
  },
  SearchDropdown: {
    highlightWords: true,
    syncSearchWithLabel: true,
    debounceTime: 300,
    lblPlaceholder: '',
    lblNoOptionsFound: 'No options found.',
    lblLoadingOptions: 'Loading options...',
    lblErrorFetchingOptions: 'Error fetching options.'
  },
  Toolbar: {
    perspectivesEnabled: true,
    buttonsConfig: JSON.stringify(EXAMPLE_TOOLBAR_BUTTONS_CONFIG, null, 4),
    customStyling: JSON.stringify({
      ...EMPTY_WIDGET_COLORS_TEMPLATE,
      toolbarBorderBottomWidth: "1px"
    }, null, 4)
  },
  IFCViewerV4: {
    ifcLdGraph: "https://wistor.nl/ifc/v4/graph/{{generated_uuid}}",
    assignRandomColorsToTags: true,
    legendSorting: "count",
    viewerOnly: false,
    contentGridTemplate: DEFAULT_LAYOUT_CONFIG.contentGridTemplate,
    infiniteDolly: false,
    dollyToCursor: true,
    verticalDragToForward: false,
    minDollyDistance: 1,
    maxDollyDistance: 300,
  }
} as const
